import { request } from './request'
const baseUrl = process.env.VUE_APP_BASEURL_USER
export const postLogin = (data) => {
  return request({
    method: 'post',
    url: `${process.env.VUE_APP_BURIER}/api/v1/user/ocean/phone/password/login-auth`,
    data
  })
}
export const postCodeLogin = (data) => {
  return request({
    method: 'post',
    url: `${baseUrl}/api/v1/user/ocean/phone/code/login-auth`,
    data
  })
}

export const postReg = (data) => {
  return request({
    method: 'post',
    url: `${baseUrl}/api/v1/user/ocean/phone/code/register`,
    data
  })
}

export const postSms = (data) => {
  return request({
    method: 'post',
    url: `${baseUrl}/api/v1/user/ocean/sms/phone/send`,
    data
  })
}
export const logout = () => {
  return request({
    method: 'get',
    url: `${baseUrl}/api/v1/user/logout/ocean`
  })
}

export const getAuth = (data) => {
  return request({
    method: 'get',
    url: `${baseUrl}/api/v1/portal/login/check`,
    data
  })
}

export const preLogin = (data) => {
  return request({
    method: 'post',
    url: `${baseUrl}/api/v1/user/ldap/login`,
    data,
    islogin: true
  })
}
//修改密码
export const changePassword = (data) => {
  const url = `${baseUrl}/api/v1/user/ocean/change/password`
  return request({
    method: 'put',
    url,
    data
  })
}